import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import FloatLabelInput from "../../../components/FloatingLabel";
import BottomMessagePopUp from "../../../components/BottomMessagePopUp";
import useGetVehicleInfo from "../../../store/selectors/get-vehicle-info";
import { getVehicleInfo } from "../../../utils/backend";
import useGetCarPlan from "../../../store/selectors/get-car-plan-quote";
import { useTranslation } from "react-i18next";
import FloatDateInput from "../../../components/FloatDateInput";
import FloatingSelect from "../../../components/FloatingSelect";

const AddOnGeneraliDriver = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const selectedPlan = useGetCarPlan();
	const { t } = useTranslation();

	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorVisible, setIsErrorVisible] = useState(false);

	const selectedAddOn = location.state?.addOn;

	const initialDrivers = JSON.parse(
		localStorage.getItem("allianz_adddriver")
	);
	const [adddriver, setAddDriver] = useState(initialDrivers || []);

	useEffect(() => {
		// Save to localStorage whenever drivers change
		localStorage.setItem("allianz_adddriver", JSON.stringify(adddriver));
	}, [adddriver]);

	if (!selectedAddOn) {
		return (
			<div className="content">
				<h3>{t(`autoInsurance.addOnSumInsured.noAddOnSelected`)}</h3>
				<Button label="Go Back" onClick={() => navigate(-1)} />
			</div>
		);
	}

	const handleInputChange = (index, field, value) => {
		const newDrivers = [...adddriver];
		newDrivers[index] = {
			...newDrivers[index],
			[field]: value,
		};
		setAddDriver(newDrivers);
	};

	const addDriverField = () => {
		if (adddriver.length >= 3) {
			setErrorMessage("You can only add 2 drivers, please select unlimited drivers instead if you want to add more.")
			setIsErrorVisible(true)
			return
		}
		const newDriver = {
			name: "",
			icnumber: "",
		};
		setAddDriver([...adddriver, newDriver]);
	};

	const removeDriverField = (index) => {
		const newDrivers = adddriver.filter((_, i) => i !== index);
		setAddDriver(newDrivers);
	};

	const handleReturnClick = (e) => {
		e.preventDefault();
		const queryParameters = new URLSearchParams(window.location.search);
		const policyId = queryParameters.get("policy_id");

		navigate(
			policyId
				? `/get-quote/add-on-others?policy_id=${policyId}`
				: `/get-quote/add-on-others`,
			{
				replace: true,
				state: {
					...selectedAddOn,
					adddriver, // Pass the sum_insured value here
				},
			}
		);
	};

	function formatDateToYYYYMMDD(date) {
		if (!(date instanceof Date)) return "";
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const day = String(date.getDate()).padStart(2, "0");
		return `${year}-${month}-${day}`;
	}

	return (
		<div className="content">
			<div className="get-quote-container">
				<h3>{`${t(`autoInsurance.addOnDrivers.title`)} ${
					selectedAddOn.title
				}`}</h3>

				<div className="add-on-details border-radius-10 w-100 mb-8rem">
					<Button
						label={t(`autoInsurance.addOnDrivers.addDriver`)}
						className="btn-secondary-fill w-100 add-nominate-button mb-2"
						onClick={addDriverField}
					/>

					{adddriver.map((driver, index) => (
						<div
							key={index}
							className="mb-2 d-flex align-items-center"
						>
							<FloatLabelInput
								className="my-2"
								label={
									selectedPlan.insurer_name !==
										"TOKIO MARINE" && index === 0
										? t(
												`healthInsurance.paymentFailed.ownerName`
										  )
										: `${t(
												`autoInsurance.addOnDrivers.driver`
										  )} ${index} ${t(
												`autoInsurance.addOnDrivers.name`
										  )}`
								}
								value={driver.name}
								onChange={(e) =>
									handleInputChange(
										index,
										"name",
										e.target.value
									)
								}
								type="text"
								disabled={
									selectedPlan.insurer_name !==
										"TOKIO MARINE" && index === 0
								}
							/>

							<FloatLabelInput
								className="my-2"
								label="Identification Number"
								value={driver.icnumber}
								onChange={(e) =>
									handleInputChange(
										index,
										"icnumber",
										e.target.value
									)
								}
								placeholder=""
								disabled={
									selectedPlan.insurer_name !==
										"TOKIO MARINE" && index === 0
								}
							/>

							{index > 0 && (
								<Button
									label={t(
										`healthInsurance.nomination.remove`
									)}
									className="p-button-danger w-100 mt-2"
									onClick={() => removeDriverField(index)}
								/>
							)}

							{index !== adddriver.length - 1 && (
								<hr
									style={{
										border: 0,
										borderTop: "1px solid #ccc",
									}}
									className="my-3 w-100"
								/>
							)}
						</div>
					))}
				</div>

				<div className={`sticky-bottom `}>
					<div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
						{/* Selected Plan and Logo Section */}
						<div className="plan-details">
							<span className="text-left formatted-text">
								{t(
									`autoInsurance.addOnSumInsured.selectingAddOnsFor`
								)}
							</span>
							<br />
							<span className="fw-bold color-heading">
								{selectedAddOn.title}
							</span>
							<p className="my-0 fw-bold insurer-name"></p>
						</div>
						<div className="col-sm-6 w-50"></div>
					</div>
					<hr />
					<Button
						label={t(`autoInsurance.addOnsOther.returnAddOns`)}
						className="btn-primary"
						onClick={(e) => handleReturnClick(e)}
					/>
					<BottomMessagePopUp
						message={errorMessage}
						type="error"
						isVisible={isErrorVisible}
						onClose={() => setIsErrorVisible(false)}
					/>
				</div>
			</div>
		</div>
	);
};

export default AddOnGeneraliDriver;
